import { render, staticRenderFns } from "./ebookApplyModel.vue?vue&type=template&id=45fa3ffb&scoped=true"
import script from "./ebookApplyModel.vue?vue&type=script&lang=js"
export * from "./ebookApplyModel.vue?vue&type=script&lang=js"
import style0 from "./ebookApplyModel.vue?vue&type=style&index=0&id=45fa3ffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa3ffb",
  null
  
)

export default component.exports